import React, { Component } from 'react';

class ErrorPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: 'React'
    };
  }

  render() {
    return (
      <div className="ui container">
        <h5 className="ui huge header">404 Page not found.. / Under construction</h5>
      </div>
    );
  }
}
export default ErrorPage;


// WEBPACK FOOTER //
// ./src/app/ui/ErrorPage.js